import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { playSoundEffect } from '../hooks/useSoundEffects';
import './ConfirmationDialog.css';

/**
 * ConfirmationDialog Component
 * Replaces native window.confirm() with a styled confirmation dialog
 */
const ConfirmationDialog = ({ 
  message, 
  onConfirm, 
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  type = 'warning'
}) => {
  useEffect(() => {
    // Play sound effect when dialog opens
    playSoundEffect('/sounds/click.mp3', 0.3);
  }, []);

  const handleConfirm = () => {
    playSoundEffect('/sounds/click.mp3');
    if (onConfirm) onConfirm();
  };

  const handleCancel = () => {
    playSoundEffect('/sounds/click.mp3');
    if (onCancel) onCancel();
  };

  const handleOverlayClick = (e) => {
    // Only close if clicking the overlay itself
    if (e.target.className === 'confirmation-overlay' || e.target.classList?.contains('confirmation-overlay')) {
      handleCancel();
    }
  };

  const typeClass = `confirmation-dialog-${type}`;

  return createPortal(
    <div 
      className="confirmation-overlay" 
      onClick={handleOverlayClick}
      style={{ zIndex: 1000000 }}
    >
      <div className={`confirmation-dialog ${typeClass}`} style={{ zIndex: 1000001 }}>
        <div className="confirmation-dialog-content">
          <div className="confirmation-dialog-message">
            {message.split('\n').map((line, index) => (
              <p key={index} style={{ margin: index > 0 ? '8px 0 0 0' : '0' }}>
                {line}
              </p>
            ))}
          </div>
          <div className="confirmation-dialog-actions">
            <button
              className="confirmation-button confirmation-button-cancel"
              onClick={handleCancel}
            >
              {cancelText}
            </button>
            <button
              className="confirmation-button confirmation-button-confirm"
              onClick={handleConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationDialog;

